var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.visibilityRules
    ? _c(
        _vm.componentType,
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.hideSubmenu,
              expression: "hideSubmenu"
            }
          ],
          tag: "router-link",
          class: [
            "main-menu__item",
            { "main-menu__item_active": _vm.showSubmenu }
          ],
          attrs: { to: _vm.item.routerLink, "data-test-id": "menu-item" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleSubmenu.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "md-tooltip",
            {
              staticClass: "custom-menu-tooltip",
              attrs: {
                "md-direction": "right",
                "md-active": _vm.tooltipActive,
                "data-test-id": "menu-item-tooltip"
              },
              on: {
                "update:mdActive": function($event) {
                  _vm.tooltipActive = $event
                },
                "update:md-active": function($event) {
                  _vm.tooltipActive = $event
                }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.item.tooltipText) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "md-icon",
            {
              staticClass: "main-menu__item-icon",
              attrs: {
                "data-test-id": "menu-item-icon",
                "md-src": _vm.item.icon.includes(".svg") ? _vm.item.icon : null
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(!_vm.item.icon.includes(".svg") && _vm.item.icon) +
                  "\n  "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "submenu" } },
            [
              _c("SubmenuList", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSubmenu,
                    expression: "showSubmenu"
                  }
                ],
                attrs: { submenuList: _vm.item.submenu },
                on: {
                  tooltipHide: function($event) {
                    _vm.tooltipActive = false
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cdb4590", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cdb4590","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/mainMenu/menuItem.vue
// module id = 6TWF
// module chunks = 1